export { default as Vendedor } from './Vendedor';
export { default as VendedorConfig } from './VendedorConfig';
